export default __webpack_public_path__ + "static/game-image-1-eng-a3494cfec5984e7d72e13e2568d47d08.png";